import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3098';

class DrawingsService {
  async getDrawings(filters = {}) {
    try {
      const params = new URLSearchParams();
      
      if (filters.phase) {
        params.append('phase', filters.phase);
      }
      
      if (filters.date) {
        params.append('date', filters.date);
      }
      
      if (filters.page) {
        params.append('page', filters.page);
      }
      
      if (filters.limit) {
        params.append('limit', filters.limit);
      }

      const response = await axios.get(`${API_BASE_URL}/cms/drawings?${params.toString()}`);
      
      if (response.data.success) {
        return {
          success: true,
          data: response.data.data,
          pagination: response.data.pagination
        };
      } else {
        return {
          success: false,
          error: response.data.error || 'Failed to fetch drawings'
        };
      }
    } catch (error) {
      console.error('Get drawings error:', error);
      
      // Check if this is a 500 Internal Server Error
      if (error.response?.status === 500) {
        return {
          success: false,
          error: `500 Internal Server Error: ${error.response?.data?.error || 'Server encountered an error'}`
        };
      }
      
      return {
        success: false,
        error: error.response?.data?.error || 'Failed to fetch drawings'
      };
    }
  }

  async updateDrawingPhase(id, phase) {
    try {
      const response = await axios.put(`${API_BASE_URL}/cms/drawings/${id}/phase`, {
        phase
      });
      
      if (response.data.success) {
        return { success: true, data: response.data.data };
      } else {
        return { success: false, error: response.data.error };
      }
    } catch (error) {
      console.error('Update drawing phase error:', error);
      return {
        success: false,
        error: error.response?.data?.error || 'Failed to update drawing phase'
      };
    }
  }

  async getDrawingsStats(queryString = '') {
    try {
      const response = await axios.get(`${API_BASE_URL}/cms/drawings/stats${queryString}`);
      
      if (response.data.success) {
        return { success: true, data: response.data.data };
      } else {
        return { success: false, error: response.data.error };
      }
    } catch (error) {
      console.error('Get drawings stats error:', error);
      return {
        success: false,
        error: error.response?.data?.error || 'Failed to fetch drawings stats'
      };
    }
  }
}

export default new DrawingsService();